import { apiClient } from '@/lib/api/client'

/**
 * SOLY-SALES-001 mini-scope 01 — Sales Cockpit follow-up API client.
 *
 * Endpoints exposed by ProjectFollowUpsController:
 *   POST /api/v2/projects/{projectId}/follow-ups  — log a new follow-up
 *   GET  /api/v2/projects/{projectId}/follow-ups  — history of logged follow-ups
 */

export type CreateFollowUpRequest = {
  note: string
  quoteVersionId?: string | null
}

export type CreateFollowUpResponse = {
  followUpId: string
  occurredAt: string
  lastFollowUpAt: string
}

export type FollowUpHistoryItem = {
  id: string
  occurredAt: string
  actorUserId: string
  actorName: string
  note: string
}

export type FollowUpHistoryResponse = {
  items: FollowUpHistoryItem[]
}

export async function postFollowUp(
  projectId: string,
  payload: CreateFollowUpRequest,
): Promise<CreateFollowUpResponse> {
  return apiClient.post<CreateFollowUpResponse>(
    `/api/v2/projects/${projectId}/follow-ups`,
    payload,
  )
}

export async function getFollowUpHistory(projectId: string): Promise<FollowUpHistoryResponse> {
  return apiClient.get<FollowUpHistoryResponse>(`/api/v2/projects/${projectId}/follow-ups`)
}
